import React from 'react';
import Config from '~/config';
import I18nLink from '~/components/I18nLink';
import themeVariables from '~/shared/themeVariables';

const NextPageButton = (props) => {
  const {
    host,
    pathname,
    query,
    as,
    t,
    type = 'see_more',
    style,
    target,
    label,
  } = props;

  let buttonLabel = label;
  if (!label) {
    if (type == 'next_page') {
      buttonLabel = t('next_page_button');
    }
    if (type == 'see_more') {
      buttonLabel = t('See more');
    }
  }
  return (
    <div className="next-page-button" style={style}>
      <I18nLink href={{ pathname, query }} as={as} host={host}>
        <a className="btn-next-page" target={target}>
          {buttonLabel}
        </a>
      </I18nLink>
      <style jsx>
        {`
          .next-page-button {
            max-width: 100%;
            width: fit-content;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            white-space: wrap;
            align-items: center;
            align-self: center;
            text-align: center;
            height: 44px;
            background: #1b2833;
          }
          .btn-next-page {
            max-width: 100%;
            width: fit-content;
            font-size: 16px;
            color: ${themeVariables.colors.white};
            border: none;
          }
          .next-page-button:hover {
            background: ${themeVariables.colors.primary};
          }
        `}
      </style>
    </div>
  );
};

export default NextPageButton;
